<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else loginFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="loginFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #loginFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="column" fxLayoutGap.lt-md="10px" class="large-paragraph-spacing" [ngClass]="{ 'ie-display': isBrowserIE }">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else loginMessagesFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="loginMessagesFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else loginMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="loginMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #loginMessagesFlexColumnTemplate>
  <div fxFlex="5%" fxHide.lt-md></div>
  <!-- Welcome Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showWelcomeMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showWelcomeMessagesSpinner && this.welcomeMessageList.length > 0"
  >
    <div
      ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
      ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
      class="extra-large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.welcomeMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <!-- Temporary Messages -->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showTemporaryMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showTemporaryMessagesSpinner && this.temporaryMessageList.length > 0"
  >
    <div
      class="large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.temporaryMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <!-- General Messages - 01/10/2023-->
  <div
    fxFlex="90%"
    fxLayoutAlign="center center"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="showGeneralMessagesSpinner"
  >
    <mat-spinner color="accent" diameter="32"></mat-spinner>
  </div>
  <div
    fxFlex="90%"
    ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
    ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
    class="large-paragraph-pre-spacing"
    *ngIf="!showGeneralMessagesSpinner && this.generalMessageList.length > 0"
  >
    <div
      class="large-display-text normal-paragraph-spacing center-text"
      [ngClass]="getMessageCssClass(item)"
      *ngFor="let item of this.generalMessageList"
    >
      {{ item.messageText }}
    </div>
  </div>
  <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #loginMainFlexColumnTemplate>
  <div fxFlex="50%" fxHide.lt-md></div>
  <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else loginFormFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="loginFormFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #loginFormFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@login.form.title">login.form.title</span></b>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
    <div class="display-text primary-dark-color-important">
      <form [formGroup]="loginForm">
        <div fxLayout="column">
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showLoginTimeoutError"
          >
            <b><span i18n="@@login.form.login-timeout-message.error.1">login.form.login-timeout-message.error.1</span></b>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="userNameVisible && userNameEnabled">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <input
                matInput
                i18n-placeholder="@@login.form.username.label"
                placeholder="login.form.username.label"
                type="email"
                [formControl]="userNameFormControl"
                autocomplete="off"
                required
              />
              <span matPrefix><mat-icon class="mat-icon-prefix">person</mat-icon>&nbsp;</span>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="userNameVisible && !userNameEnabled">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <input
                matInput
                i18n-placeholder="@@login.form.username.label"
                placeholder="login.form.username.label"
                type="email"
                [value]="loginForm.get('userNameFormControl').value"
                autocomplete="off"
                readonly
                disabled
              />
              <span matPrefix><mat-icon class="mat-icon-prefix">person</mat-icon>&nbsp;</span>
              <mat-icon matSuffix>done</mat-icon>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="userPasswordVisible">
            <mat-form-field fxFlex="80%" fxFlex.lt-md="90%">
              <input
                #userPasswordRef
                matInput
                i18n-placeholder="@@login.form.password.label"
                placeholder="login.form.password.label"
                type="password"
                [formControl]="userPasswordFormControl"
                autocomplete="off"
                required
              />
              <span matPrefix><mat-icon class="mat-icon-prefix">lock</mat-icon>&nbsp;</span>
            </mat-form-field>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="display-text normal-paragraph-spacing"
            *ngIf="userNameButtonVisible || userPasswordButtonVisible"
          >
            <button
              mat-flat-button
              color="primary"
              (click)="verifyUserName()"
              i18n="@@login.form.login-button.label"
              [disabled]="!loginUserEnabled() || showLockedOutError || showTemporaryPasswordError || showExpiredTemporaryPasswordError"
              *ngIf="userNameButtonVisible"
            >
              login.form.login-button.label
            </button>
            <button
              mat-flat-button
              color="primary"
              (click)="submitUser()"
              i18n="@@login.form.submit-button.label"
              [disabled]="!submitUserEnabled() || showLockedOutError || showTemporaryPasswordError || showExpiredTemporaryPasswordError"
              *ngIf="userPasswordButtonVisible"
            >
              login.form.submit-button.label
            </button>
            <span *ngIf="userPasswordButtonVisible">&nbsp;&nbsp;</span>
            <button
              mat-stroked-button
              color="primary"
              (click)="cancelLogin()"
              i18n="@@login.form.cancel-button.label"
              *ngIf="userPasswordButtonVisible"
            >
              login.form.cancel-button.label
            </button>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showVerifyUserNameError"
          >
            <b><span i18n="@@login.form.verify-user-name-message.error.1">login.form.verify-user-name-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showVerifyUserNameError"
          >
            <b><span i18n="@@login.form.verify-user-name-message.error.2">login.form.verify-user-name-message.error.2</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showLockedOutError"
          >
            <b><span i18n="@@login.form.locked-out-message.error.1">login.form.locked-out-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showTemporaryPasswordError"
          >
            <b><span i18n="@@login.form.temporary-password-message.error.1">login.form.temporary-password-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showExpiredTemporaryPasswordError"
          >
            <b
              ><span i18n="@@login.form.expired-temporary-password-message.error.1"
                >login.form.expired-temporary-password-message.error.1</span
              ></b
            >
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showLoginError"
          >
            <b><span i18n="@@login.form.login-message.error.1">login.form.login-message.error.1</span></b>
          </div>
          <div
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showLoginError"
          >
            <b><span i18n="@@login.form.login-message.error.2">login.form.login-message.error.2</span></b>
          </div>
          <div
          fxLayoutAlign="center center"
          style="text-align: center;"
          class="display-text warning-color normal-paragraph-spacing"
          *ngIf="showBlockedIPError"
        >
          <b><span i18n="@@login.form.blocked-ip.error.1">login.form.blocked-ip.error.1</span></b>
        </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="normal-paragraph-spacing"
            *ngIf="
              userNameVisible && userNameEnabled && !showLockedOutError && !showTemporaryPasswordError && !showExpiredTemporaryPasswordError
            "
          >
            <a (click)="forgotUserName()" class="anchor-link accent-color-important" i18n="@@login.form.forgot-username-link.label"
              >login.form.forgot-username-link.label</a
            >
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="normal-paragraph-spacing"
            *ngIf="userPasswordButtonVisible || showLockedOutError || showTemporaryPasswordError || showExpiredTemporaryPasswordError"
          >
            <a (click)="forgotPassword()" class="anchor-link accent-color-important" i18n="@@login.form.forgot-password-link.label"
              >login.form.forgot-password-link.label</a
            >
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showLoginSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
          </div>
          <div class="display-text primary-dark-color-important normal-paragraph-pre-spacing" *ngIf="registerVisible">
            <b><span i18n="@@login.form.no-account">login.form.no-account</span></b>
          </div>
          <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;" *ngIf="registerVisible"></div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="registerVisible">
            <button mat-flat-button color="primary" (click)="registerUser()" i18n="@@login.form.register-button.label">
              login.form.register-button.label
            </button>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-pre-spacing">
            <br>
            <b><span i18n="@@login.form.title.qp">login.form.title.qp</span></b>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
